import styles from './PageProductValuePropositions.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function PageProductValuePropositionsItem({
  valuePropositionProductSku,
  title,
  subtitle,
  description,
  descriptionList,
  iconUrl,
  imageUrl,
  objectFit,
  endLinkText,
  endLinkUrl,
  disclaimer,
}) {
  const { theme } = useSearchParamOrDefaultProps();

  return (
    <>
      <div
        className={classNames(styles.detailsWrapper, {
          [styles.proProductBackgroundColor]:
            theme === 'pro' ||
            (theme === 'allAccess' && valuePropositionProductSku === 'PRO'),
          [styles.investingClubProductBackgroundColor]:
            theme === 'investingClub' ||
            (theme === 'allAccess' &&
              valuePropositionProductSku === 'InvestingClub'),
          [styles.allAccessProductBackgroundColor]:
            (theme === 'allAccess' &&
              valuePropositionProductSku === 'ProICBundle') ||
            (theme === 'pro' && valuePropositionProductSku === 'ProICBundle'),
          [styles.registeredOnlyProductBackgroundColor]:
            theme === 'registeredOnly' ||
            (theme === 'allAccess' &&
              valuePropositionProductSku === 'RegisteredOnly'),
          [styles.descriptionList]: !!descriptionList,
        })}
      >
        <div className={styles.itemContainer}>
          {iconUrl && subtitle && (
            <div className={styles.subtitleWrapper}>
              <img className={styles.icon} src={iconUrl} alt={subtitle} />
              <h3 className={styles.subtitle}>{subtitle}</h3>
            </div>
          )}
          <h2 className={styles.title}>{title}</h2>
          {description && <p className={styles.description}>{description}</p>}
          {descriptionList && (
            <div className={styles.description}>
              <ul className={styles.descriptionList}>
                {descriptionList.map((listItem, index) => (
                  <li key={`${index}${listItem}`}>{listItem}</li>
                ))}
              </ul>
            </div>
          )}
          {endLinkText && endLinkUrl && (
            <a href={endLinkUrl} className={styles.descriptionEndLink}>
              {endLinkText}
            </a>
          )}
          {disclaimer && <p className={styles.disclaimer}>{disclaimer}</p>}
        </div>
      </div>
      <div className={styles.imageWrapper}>
        <img
          className={classNames(styles.image, {
            [styles.fitImage]: objectFit === 'contain',
          })}
          src={imageUrl}
          loading="lazy"
        />
      </div>
    </>
  );
}

PageProductValuePropositionsItem.propTypes = {
  valuePropositionProductSku: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  descriptionList: PropTypes.arrayOf(PropTypes.string),
  iconUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  objectFit: PropTypes.string,
  endLinkText: PropTypes.string,
  endLinkUrl: PropTypes.string,
  disclaimer: PropTypes.string,
};

export default PageProductValuePropositionsItem;
